import React from "react";

export default ({ width = 16, height = 16, fill = "#2495e1", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00016 1.75016C4.10067 1.75016 1.75016 4.10067 1.75016 7.00016C1.75016 9.89966 4.10067 12.2502 7.00016 12.2502C9.89966 12.2502 12.2502 9.89966 12.2502 7.00016C12.2502 4.10067 9.89966 1.75016 7.00016 1.75016ZM0.583496 7.00016C0.583496 3.45634 3.45634 0.583496 7.00016 0.583496C10.544 0.583496 13.4168 3.45634 13.4168 7.00016C13.4168 10.544 10.544 13.4168 7.00016 13.4168C3.45634 13.4168 0.583496 10.544 0.583496 7.00016Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99984 4.0835C7.322 4.0835 7.58317 4.34466 7.58317 4.66683V7.00016C7.58317 7.32233 7.322 7.5835 6.99984 7.5835C6.67767 7.5835 6.4165 7.32233 6.4165 7.00016V4.66683C6.4165 4.34466 6.67767 4.0835 6.99984 4.0835Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.4165 9.33333C6.4165 9.01117 6.67767 8.75 6.99984 8.75H7.00567C7.32784 8.75 7.589 9.01117 7.589 9.33333C7.589 9.6555 7.32784 9.91667 7.00567 9.91667H6.99984C6.67767 9.91667 6.4165 9.6555 6.4165 9.33333Z"
      />
    </svg>
  );
};
